const smsTemplateTokens = {
  "isPaidSMS": [
    {
      label: "نام مشتری",
      token: "{{customerName}}",
      example: "میثم شمشیری"
    },
    {
      label: "کد سفارش",
      token: "{{orderCode}}",
      example: "3793"
    },
    {
      label: "لینک پیگیری",
      token: "{{orderLink}}",
      example: "https://test.farasod.com?order=a15q47we8x"
    },
    {
      label: "کد پیگیری",
      token: "{{referenceCode}}",
      example: "a15q47we8x"
    },
    {
      label: "نام فروشگاه یا رستوران",
      token: "{{shopName}}",
      example: "گود فود"
    }
  ],
  "orderIsReadySMS": [
    {
      label: "نام مشتری",
      token: "{{customerName}}",
      example: "میثم شمشیری"
    },
    {
      label: "کد سفارش",
      token: "{{orderCode}}",
      example: "3793"
    }
  ]
}

export default smsTemplateTokens